module.exports = __webpack_public_path__ + "img/autismqld.6361654.png";